
































































































































































import NavigationEntryTemplate from '@/views/pageskeleton/NavigationEntryTemplate.vue';
import sortable from '@/directives/sort.directive';
import Vue from 'vue';
import Component from 'vue-class-component';
import {Watch} from 'vue-property-decorator';
import {SortableEvent} from 'sortablejs';
import store from '@/store';
import CompanyChangeTemplate from '@/views/pageskeleton/companychange/CompanyChangeTemplate.vue';
import ThemeSwitch from '@/fields/theme/ThemeSwitch.vue';
import {IDENTITY_SERVICE_INSTANCE} from '@/services/identity.service';

@Component({
  components: {
    CompanyChangeTemplate,
    NavigationEntryTemplate,
    ThemeSwitch
  },
  directives: {
    sortable
  }
})
export default class NavigationTemplate extends Vue {
  private static readonly DOCUMENTATION_URL = '/dokumentation/INDEX.html';

  navigationTabIndex = 0;

  user: DisguiseDto.UserDataDto = store.state.user;
  naviEntries: Array<DisguiseDto.NaviEntryDto<DisguiseDto.SimpleNaviTypeDtoUnion>> =
      store.state.navi;
  favorites: { [id: number]: boolean } = {};
  orderedFavorites: Array<DisguiseDto.NaviEntryDto<DisguiseDto.SimpleNaviTypeDtoUnion>> =
      store.state.naviFavorites;

  // State of the mouse
  mouseOverButton: boolean = false;
  mouseOverMenu: boolean = false;
  mouseOverDropDown: boolean = false;
  loadingStates: { [id: number]: boolean } = {};
  hideNavi: boolean = false;
  // Set a timeout so that the menu doesn't close before the user has time to
  // move their mouse over it
  // We can set it to 0, because our menu move into the sidebar and and so
  // our cursor is over the navigation and mouseOverMenu triggers
  // ! Is needed to give the user time the avatar to the dropdown
  private timeoutLength = 150;

  enterDropdown = () => {
    this.mouseOverDropDown = true;
  }
  leaveDropdown = () => {
    this.mouseOverDropDown = false;
    setTimeout(() => {
      if (!this.mouseOverMenu) {
        this.$store.commit('hideNavigation');
      }
    }, this.timeoutLength);
  }

  enterButton = () => {
    if (!this.$store.state.navigation.show) {
      this.$store.commit('showNavigation');
    }
  }

  leaveButton = () => {
    setTimeout(() => {
      this.mouseOverButton = false;
      if (!this.mouseOverMenu && !this.mouseOverDropDown) {
        this.$store.commit('hideNavigation');
      }
    }, this.timeoutLength);
  }

  enterMenu = () => {
    this.mouseOverMenu = true;
  }

  leaveMenu = () => {
    setTimeout(() => {
      this.mouseOverMenu = false;
      if (!this.mouseOverDropDown) {
        this.$store.commit('hideNavigation');
      }
    }, this.timeoutLength);
  }

  @Watch('$store.state.user') onUserUpdated(value: DisguiseDto.UserDataDto) {
    this.user = value;
  }

  @Watch('$store.state.navi', {
    deep: true
  }) onNaviUpdated(
      navi: Array<DisguiseDto.NaviEntryDto<DisguiseDto.SimpleNaviTypeDtoUnion>>
  ) {
    this.naviEntries = navi;
  }

  @Watch('$store.state.naviFavorites') onNaviFavoritesUpdated(
      favorites: Array<DisguiseDto.NaviEntryDto<DisguiseDto.SimpleNaviTypeDtoUnion>>
  ) {
    const newFavorites: { [id: number]: boolean } = {};
    for (const favorite of favorites) {
      newFavorites[favorite.id || 0] = true;
    }
    this.favorites = newFavorites;
    this.orderedFavorites = favorites;
  }

  @Watch('$store.state.hideNavi') onHideNaviUpdated(
      hidden: boolean
  ) {
    this.hideNavi = hidden;
  }

  created() {
    this.onNaviFavoritesUpdated(this.$store.state.naviFavorites || []);
    this.hideNavi = store.state.hideNavi;
  }

  mounted() {
    this.onResize();

    window.addEventListener('resize', this.onResize);
  }

  updateFavoriteOrder(evt: SortableEvent) {
    const oldIndex = evt.oldIndex || 0;
    const newIndex = evt.newIndex || 0;

    const favorites = this.orderedFavorites;
    const newIndexOutOfBounds = newIndex > favorites.length - 1;
    const oldIndexOutOfBounds = oldIndex > favorites.length - 1;
    if (newIndexOutOfBounds || oldIndexOutOfBounds) {
      return;
    }

    const arrayCopy: Array<DisguiseDto.NaviEntryDto<DisguiseDto.SimpleNaviTypeDtoUnion>> =
        [...favorites];
    if (newIndex >= arrayCopy.length) {
      let k = newIndex - arrayCopy.length + 1;
      while (k--) {
        arrayCopy.push({});
      }
    }
    arrayCopy.splice(newIndex, 0, arrayCopy.splice(oldIndex, 1)[0]);

    this.$store.dispatch('reorderNaviFavorites', {naviEntries: arrayCopy}).then(() => {
      // ok
    }, () => {
      this.$store.commit('showSnack', {
        message: 'Fehler beim Datenaustausch',
        color: 'error'
      });
    });
  }

  deleteFavorite(
      favorite: DisguiseDto.NaviEntryDto<DisguiseDto.SimpleNaviTypeDtoUnion>,
      $event: Event
  ) {
    $event.preventDefault();
    this.loadingStates = {
      ...this.loadingStates,
      [favorite.id || 0]: true
    };
    this.$store.dispatch('deleteNaviFavorite', {naviEntry: favorite}).then(() => {
      this.loadingStates = {
        ...this.loadingStates,
        [favorite.id || 0]: false
      };
      // ok
    }, () => {
      this.loadingStates = {
        ...this.loadingStates,
        [favorite.id || 0]: false
      };
      this.$store.commit('showSnack', {
        message: 'Fehler beim Datenaustausch',
        color: 'error'
      });
    });
  }

  openNaviSearch() {
    this.$store.commit('showNaviSearch');
  }

  openDocumentation() {
    window.open(NavigationTemplate.DOCUMENTATION_URL, '_blank');
  }

  checkRefreshToken(): boolean {
    return !IDENTITY_SERVICE_INSTANCE.isRefreshTokenExpired();
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    if (this.$store.state.navigation.isLocked && this.$vuetify.breakpoint.mdAndUp) {
      this.enterButton();
    }
  }

}
